import { ReactElement, useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { Tooltip } from "antd";

import "./countries.scss";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import CustomTable from "../../components/custom-table/custom-table";
import { useDispatch, useSelector } from "react-redux";
import { CREATE_BREADCRUMB, LOADING } from "../../store/actions";
import instance from "../../store/axios";
import { AxiosResponse } from "axios";
import CustomSearch from "../../components/custom-search/custom-search";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import ReactCountryFlag from "react-country-flag";

const Countries: React.FC = (): ReactElement => {
  const dispatch = useDispatch();
  const loadingState = useSelector((state: any) => state?.loading);
  const user = useSelector((state: any) => state.user);
  const [countriesData, setCountriesData] = useState([]);

  useEffect(() => {
    getCountriesData();
    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: "Countries",
            type: "link",
            link: "/countries",
          },
        ],
      },
    });
  }, []);

  const getCountriesData = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/countries?partial=${1}`
      );
      setCountriesData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/countries`);
    }

    dispatch({ type: LOADING, payload: false });
  };

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
    },
    {
      title: "Flag",
      dataIndex: "flag",
      key: "flag",
      fixed: "left",
      render: (_, record) => (
        <ReactCountryFlag
          style={{
            fontSize: "24px",
            marginInlineEnd: "8px",
          }}
          countryCode={record?.countryCode}
          svg
        />
      ),
    },
    {
      title: "Name En",
      dataIndex: "nameEn",
      key: "nameEn",
      sorter: (a, b) => String(a?.nameEn).localeCompare(String(b?.nameEn)),
      fixed: "left",
      render: (text, record) =>
        user?.permissions.includes("view_states") ? (
          <Link to={`/states/${record.id}`}>{text}</Link>
        ) : (
          <span>{text}</span>
        ),
    },
    {
      title: "Name Ar",
      dataIndex: "nameAr",
      key: "nameAr",
      width: 120,
      sorter: (a, b) => String(a?.nameAr).localeCompare(String(b?.nameAr)),
    },
    {
      title: "Nationality En",
      dataIndex: "nationalityEn",
      key: "nationalityEn",
      sorter: (a, b) =>
        String(a?.nationalityEn).localeCompare(String(b?.nationalityEn)),
      width: 150,
    },
    {
      title: "Nationality Ar",
      dataIndex: "nationalityAr",
      key: "nationalityAr",
      sorter: (a, b) =>
        String(a?.nationalityAr).localeCompare(String(b?.nationalityAr)),
      width: 150,
    },
    {
      title: "Country code",
      dataIndex: "countryCode",
      key: "countryCode",
      sorter: (a, b) =>
        String(a?.countryCode).localeCompare(String(b?.countryCode)),
      width: 150,
    },
    {
      title: "Calling code",
      dataIndex: "callingCode",
      key: "callingCode",
      sorter: (a, b) =>
        String(a?.callingCode).localeCompare(String(b?.callingCode)),
      width: 150,
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
      sorter: (a, b) => a.order - b.order,
    },
    // {
    //   title: "Actions",
    //   key: "actions",
    //   width: 150,
    //   render: () => (
    //     <div className="actions flex align-center">
    //       <ReactSVG src={EditImage} />
    //       <ReactSVG
    //         className="delete-icon"
    //         src={DeleteImage}
    //         onClick={() => setDeleteModal(true)}
    //       />
    //     </div>
    //   ),
    // },
  ];

  return (
    <section className="countries-container flex column">
      <div className="flex align-center justify-space-between">
        <BreadcrumbComponent />
      </div>

      <div className="countries-table">
        <div className="title flex align-center justify-space-between">
          <p>{!loadingState ? countriesData?.length : ""} Countries</p>
          <div className="images flex align-center">
            {/* <CustomSearch />
            <Tooltip placement="topLeft" title="Columns settings">
              <img src={"/images/grid.svg"} alt="grid" />
            </Tooltip>
            <Tooltip placement="topLeft" title="Export">
              <img src={"/images/export.svg"} alt="export-customers" />
            </Tooltip>
            <Tooltip placement="topLeft" title="Upload">
              <img src={"/images/upload.svg"} alt="upload-customers" />
            </Tooltip> */}
          </div>
        </div>
        {countriesData?.length ? (
          <CustomTable
            columns={columns}
            data={countriesData}
            showPagination={false}
          />
        ) : !loadingState ? (
          <div className="flex flex-col gap-3 w-full items-center justify-center mt-9">
            <img
              className="w-[40px] h-[40px]"
              src="/images/no-items.svg"
              alt="no data kamco"
            />
            <p className="text-lg text-gray-500 font-medium">
              There are no items in this list
            </p>
          </div>
        ) : (
          ""
        )}
      </div>
    </section>
  );
};

export default Countries;
